








import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import PointGet from '@/components/molecules/PointGet.vue'
import { State } from '@/store/modules/stamps'
import { decodeStampUUID } from '@/utils'

export default Vue.extend({
  name: 'CaptureStamp',
  components: {
    SimpleLoader,
    PageTitle,
    PointGet
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.stamps.isStampCapturing
    },
    stamp(): State['capturedStamp'] | null {
      return this.$state.stamps.capturedStamp
    }
  },
  methods: {
    capture() {
      this.$store.dispatch('stamps/postCaptureStamp', {
        stamp_id: decodeStampUUID(this.$route.params.id)
      })
    },
    captureWithPosition(position: any) {
      this.$store.dispatch('stamps/postCaptureStamp', {
        stamp_id: decodeStampUUID(this.$route.params.id),
        location: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
      })
    },
    error() {
      this.$store.dispatch(
        'flash/setMessage',
        {
          message: 'ポイントの取得に失敗しました',
          isAlert: true
        },
        {
          root: true
        }
      )
    }
  },
  mounted() {
    if (!this.$state.stamps.capturedStamp) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.captureWithPosition, this.error, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        })
      } else {
        this.capture()
      }
    }
  }
})
